import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import queryString from 'query-string'
import BasePage from '../BasePage';
import { Row, Col, Button } from 'react-bootstrap';
import { fetchGenericData } from '../../../../webservices/generic/genericDataWs';
import { showDataFetchError } from '../../../../actions/generic/fuseAlerts';
import { fetchPermissions } from '../../../../webservices/roles/rolesWs';
import RolesLinkedPanel from './RolesLinkedPanel';
import RolesPanel from './RolesPanel';

class RolesPage extends React.Component{

    constructor(props) {
        super(props);
        this.state = {  
			data: {},
			selectedRow: null	
        };
    } 
    
    componentDidMount(){
    }

	loadRowData = (row)=>{
		this.setState({selectedRow: row});
	}
 

    render(){
        // if (_.isEmpty(this.props.screenInfo || _.isEmpty(this.state.data))){
        //     return null;
        // }
  
        return (
            <BasePage>
				<RolesPanel title="Roles" rowSelected={this.loadRowData}/><br/>
				{ !_.isEmpty(this.state.selectedRow) && <>
				<RolesLinkedPanel title='Screen' columns={screenColumns} roleName={this.state.selectedRow.name} dataType='Screen'/><br/>
				<RolesLinkedPanel title='Menu' columns={menuColumns} roleName={this.state.selectedRow.name} dataType='Menu'/><br/>
				</>}
            </BasePage>);
      }
	  
      componentDidUpdate(prevProps) {
      }
  
  }
  
  RolesPage.propTypes = {
    // fetchScreenInfo: PropTypes.func.isRequired
  };

  const mapStateToProps = (state, ownProps) => {
    const values = queryString.parse(ownProps.location.search)
      return{
          fetchingData: state.fetchingData === true,
          auth: state.auth,
          screenId: values.screenId,
          parent: values.parent,
          screenInfo: state.screenInfo
      };
  }

const menuColumns = [{name: "screenName",
	description: "Screen Name",
	columnType: "String",
	updateable: false
	},{name: "screenDesc",
	description: "Screen Description",
	columnType: "String",
	updateable: false
	},{name: "menu",
	description: "Accessible",
	columnType: "Boolean",
	updateable: true
}];

const screenColumns = [{name: "screenName",
	description: "Screen Name",
	columnType: "String",
	updateable: false
	},{name: "screenDesc",
	description: "Screen Description",
	columnType: "String",
	updateable: false //SB: I am temporarily commenting out these columns as I'm not sure Seacom will need all these. Let's expose them as we add functionality.
	},/*{name: "action",
	description: "Action",
	columnType: "Boolean",
	updateable: true
	},{name: "approve",
	description: "Approve",
	columnType: "Boolean",
	updateable: true
	},*/{name: "delete",
	description: "Delete",
	columnType: "Boolean",
	updateable: true //SB: I am temporarily commenting out these columns as I'm not sure Seacom will need all these. Let's expose them as we add functionality.
	},/*{name: "help",
	description: "Help",
	columnType: "Boolean",
	updateable: true
	},{name: "history",
	description: "History",
	columnType: "Boolean",
	updateable: true
	}*/,{name: "insert",
	description: "Insert",
	columnType: "Boolean",
	updateable: true
	},{name: "read",
	description: "Read",
	columnType: "Boolean",
	updateable: true
	},{name: "update",
	description: "Update",
	columnType: "Boolean",
	updateable: true
	}
];
  
  export default connect(
      mapStateToProps, 
      (dispatch, ownProps) => ({
		showDataFetchError: (exception) => dispatch(showDataFetchError(exception)),
        })
      )(RolesPage);